import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react-pro';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setShow } from '../../../actions/general';
import { LOCAL_CART, LOCAL_LICENSEE, MODAL_LOGIN } from '../../../constants';
import { checkLicenseeUserAndCart, getCountriesList } from '../../../utils';
import { setCurrentLicensee, setSubscriberLicenseeId } from '../../CMS/Subscriber/Licensees/actions';
import { SelectSearchField } from '../Forms';

const LicenseePopup = () => {
     const dispatch = useDispatch();
     const licensees = useSelector((state) => state.subscriber.licensees);
     const currentLocation = useSelector((state) => state.subscriber.currentLocation || {});
     const { country_code } = currentLocation;
     const productsListId = useSelector((state) => state.subscriber.productsListId);
     const cartLocalStorage = JSON.parse(localStorage.getItem(LOCAL_CART));
     const countriesList = getCountriesList(licensees);
     const filterLicensee = getCountriesList(licensees).find((item) => item.value === country_code);
     const licenseeByIp = filterLicensee ?? '';
     const initLicenseeValue = licenseeByIp?.value + '_' + licenseeByIp?.licenseeId;
     const licenseesOptions = countriesList.map((element) => {
          return { ...element, value: element.value + '_' + element.licenseeId };
     });

     const [licenseeValue, setLicenseeValue] = useState();

     useEffect(() => {
          if (licenseeByIp) {
               setLicenseeValue(initLicenseeValue);
          }
     }, [initLicenseeValue]); // eslint-disable-line react-hooks/exhaustive-deps

     const licenseeSelected = licenseeValue && licenseesOptions.find((licenseesOption) => licenseesOption.value === licenseeValue);

     const handleChangeSelect = (e) => {
          setLicenseeValue(e.value);
     };

     const handleConfirmMyCountry = () => {
          if (!licenseeValue) return;

          // let licenseeId = licenseesOptions[0].value.split('_')[1];
          // let licenseeLabel = licenseesOptions[0].value.split('_')[0];

          const data = licenseeValue.split('_');
          const licenseeId = data[1];
          const licenseeLabel = data[0];

          checkLicenseeUserAndCart(cartLocalStorage, licenseeId, productsListId);

          // Set current licenseeId
          dispatch(setSubscriberLicenseeId(licenseeId));

          const licensee = {
               label: licenseeLabel,
               value: licenseeId,
          };
          localStorage.setItem(LOCAL_LICENSEE, JSON.stringify(licensee));
          dispatch(setCurrentLicensee(licensee));
     };

     return (
          <CModal alignment="center" visible>
               <CModalBody>
                    <h3 className="mb-3 popup-title">Please Confirm Your Country</h3>
                    <p className="popup-description">
                         Products may differ by country. Please select and confirm your country before browsing products.
                    </p>

                    <SelectSearchField
                         classNameWrap="input-custom-wrap"
                         classNameInput="input-custom select-search-custom"
                         id="country"
                         placeholder="Select Country..."
                         options={licenseesOptions}
                         selectInputType={false}
                         value={licenseeSelected}
                         onChange={handleChangeSelect}
                         classNamePrefix="licensee-popup"
                    />
                    <div className="mt-3 text-center">
                         <CButton className="text-uppercase btn-blue-highlight btn-round-9 btn-h-50" type="submit" onClick={handleConfirmMyCountry}>
                              Confirm My Country
                         </CButton>
                    </div>
               </CModalBody>
               <CModalFooter className="justify-content-center">
                    <p className="text-center">
                         Already have an account?{' '}
                         <Link
                              to=""
                              onClick={(e) => {
                                   e.preventDefault();
                                   dispatch(setShow(MODAL_LOGIN));
                              }}
                         >
                              Log in to buy training products.
                         </Link>
                    </p>
               </CModalFooter>
          </CModal>
     );
};

export default LicenseePopup;
